import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  ThemeProvider as MuiThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Footer from "../Components/Layout/Footer";
import Logo from "../Components/Layout/Logo";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const About = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <div className="showcase">
        <Banner />
        <IntroOne />
        <IntroTwo />
        <IntroThree />
        <Section />
        <Footer />
      </div>
    </MuiThemeProvider>
  );
};

const Banner = () => {
  return (
    <div className="banner">
      <AppBar
        color="inherit"
        position="fixed"
        style={{
          backdropFilter: "blur(30px) !important",
          boxShadow: "none",
        }}
      >
        <Toolbar
          component="div"
          variant="regular"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Logo />
          <Typography edge="start" variant="h4" style={{ fontWeight: "bold" }}>
            About Studybud
          </Typography>
          <Button
            variant="outlined"
            component={Link}
            to="/login"
            size="small"
            color="inherit"
          >
            Login
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

const IntroOne = () => {
  return (
    <div className="intro-one">
      <div className="intro-heading-one">
        <Typography variant="h5" style={{ fontWeight: "600" }}>
          Who we are
        </Typography>
        <Typography variant="h4" style={{ fontWeight: "400" }}>
          Studybud is an African online social media and social networking
          service aimed at students of age 13 and above.
        </Typography>
      </div>
      <div className="box-one"></div>
    </div>
  );
};

const IntroTwo = () => {
  return (
    <div className="intro-two">
      <div className="intro-heading-two">
        <Typography variant="h5" style={{ fontWeight: "600" }}>
          Our vision
        </Typography>
        <Typography variant="h4" style={{ fontWeight: "400" }}>
          is to revolutionize education and create digital experiences for
          students to learn at their own pace.
        </Typography>
      </div>
      <div className="box-two"></div>
    </div>
  );
};

const IntroThree = () => {
  return (
    <div className="intro-three">
      <div className="intro-heading-three">
        <Typography variant="h5" style={{ fontWeight: "600" }}>
          Our Mission
        </Typography>
        <Typography variant="h4" style={{ fontWeight: "400" }}>
          is to connect students in Nigeria and across Africa together to learn from each other,share ideas
          and experience.
        </Typography>
      </div>
      <div className="box-three"></div>
    </div>
  );
};

const Section = () => {
  return (
    <div className="section">
      <Typography variant="h3" style={{ fontWeight: "bold" }}>
        Join Studybud today.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: "1rem", color: "white" }}
        component={Link}
        to="/signup"
      >
        Sign up Now!
      </Button>
    </div>
  );
};

export default About;
